/**
 * 模态顶级容器
 * @author chenqunfeng
 * @since 17/10/21
 */

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from 'components/modal';
import { showModal, hideModal } from 'actions/modal';

const mapStateToProps = state => {
  return {
    userInfo: state.userInfo,
    modal: state.modal,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      showModal,
      hideModal,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Modal);
